/* eslint-disable prettier/prettier */
import React, { useContext, useState } from 'react';
import './styles.css';
import { GlobalContext } from '../../contexts/HomeContext';
import { Capitalize, FormataValor } from '../../utils/utils';
import { Button } from '../Button';

import P from 'prop-types';
import { Tabs } from '../Tabs';
import { InformacaoPagamento } from '../InformacaoPagamento';

export const Informacoes = ({ handleModal }) => {
  const { dadosApp, statusLoja } = useContext(GlobalContext);
  const [tabActive, setTabActive] = useState(0);
  const config = dadosApp.Empresa.Config;
  const dados = dadosApp.Empresa.Empresa;

  const formatarHora = (hora) => {
    let horaSplt = hora.split(':');
    return horaSplt[0].toString() + ':' + horaSplt[1].toString();
  };

  const hoje = new Date(Date.now());
  return (
    <div>
      <Tabs active={tabActive} setTabActive={setTabActive} text1='Horário' text2='Pagamento' />

      {tabActive === 0 && (
        <div className="modal-content-dialog cardShadow" style={{ margin: 10, border: 'none' }}>
          <>
            <div className="info-card-border-bottom">
              <div className="info-card-content">
                <p>{Capitalize(dadosApp.Empresa.Empresa.razao)}</p>
                <p>CNPJ: {dadosApp.Empresa.Empresa.cpf_cnpj}</p>
              </div>
            </div>

            <div className="info-card-border-bottom" style={{ borderBottom: 'none', paddingBottom: '0' }}>
              <h6 className="info-card-title">Dias e Horários de Entrega</h6>
              <div className="info-card-content" style={{ margin: '0 -10px' }}>
                {config.domingo == 1 && (
                  <div
                    className="info-card-block"
                    style={
                      hoje.getDay() == 0
                        ? { color: statusLoja.StatusLoja ? 'rgb(0, 180, 164)' : 'red', background: '#f9f9f9' }
                        : {}
                    }
                  >
                    <span
                      style={{
                        marginLeft: '15px',
                        marginTop: config.dom_intervalo == 1 ? '15px' : '0',
                        gridRow: config.dom_intervalo == 1 ? '1 / 3' : '1 / 2',
                      }}
                    >
                      Domingo
                    </span>
                    {config.dom_intervalo == 0 && (
                      <span>
                        {formatarHora(config.dom_abertura)} às {formatarHora(config.dom_fechamento)}
                      </span>
                    )}
                    {config.dom_intervalo == 1 && (
                      <>
                        <span>
                          {formatarHora(config.dom_abertura)} às {formatarHora(config.dom_intervalo_abertura)}
                        </span>
                        <span style={{ gridColumn: '2', paddingTop: '0' }}>
                          {formatarHora(config.dom_intervalo_fechamento)} às {formatarHora(config.dom_fechamento)}
                        </span>
                      </>
                    )}
                  </div>
                )}
                {config.domingo == 0 && (
                  <div
                    className="info-card-block"
                    style={hoje.getDay() == 0 ? { color: 'red', background: '#f9f9f9' } : { color: 'silver' }}
                  >
                    <span style={{ marginLeft: '15px' }}>Domingo</span>
                    <span>Não Abre</span>
                  </div>
                )}

                {config.segunda == 1 && (
                  <div
                    className="info-card-block"
                    style={
                      hoje.getDay() == 1
                        ? { color: statusLoja.StatusLoja ? 'rgb(0, 180, 164)' : 'red', background: '#f9f9f9' }
                        : {}
                    }
                  >
                    <span
                      style={{
                        marginLeft: '15px',
                        marginTop: config.seg_intervalo == 1 ? '15px' : '0',
                        gridRow: config.seg_intervalo == 1 ? '1 / 3' : '1 / 2',
                      }}
                    >
                      Segunda
                    </span>
                    {config.seg_intervalo == 0 && (
                      <span>
                        {formatarHora(config.seg_abertura)} às {formatarHora(config.seg_fechamento)}
                      </span>
                    )}
                    {config.seg_intervalo == 1 && (
                      <>
                        <span>
                          {formatarHora(config.seg_abertura)} às {formatarHora(config.seg_intervalo_abertura)}
                        </span>
                        <span style={{ gridColumn: '2', paddingTop: '0' }}>
                          {formatarHora(config.seg_intervalo_fechamento)} às {formatarHora(config.seg_fechamento)}
                        </span>
                      </>
                    )}
                  </div>
                )}
                {config.segunda == 0 && (
                  <div
                    className="info-card-block"
                    style={hoje.getDay() == 1 ? { color: 'red', background: '#f9f9f9' } : { color: 'silver' }}
                  >
                    <span style={{ marginLeft: '15px' }}>Segunda</span>
                    <span>Não Abre</span>
                  </div>
                )}

                {config.terca == 1 && (
                  <div
                    className="info-card-block"
                    style={
                      hoje.getDay() == 2
                        ? { color: statusLoja.StatusLoja ? 'rgb(0, 180, 164)' : 'red', background: '#f9f9f9' }
                        : {}
                    }
                  >
                    <span
                      style={{
                        marginLeft: '15px',
                        marginTop: config.ter_intervalo == 1 ? '15px' : '0',
                        gridRow: config.ter_intervalo == 1 ? '1 / 3' : '1 / 2',
                      }}
                    >
                      Terça
                    </span>
                    {config.ter_intervalo == 0 && (
                      <span>
                        {formatarHora(config.ter_abertura)} às {formatarHora(config.ter_fechamento)}
                      </span>
                    )}
                    {config.ter_intervalo == 1 && (
                      <>
                        <span>
                          {formatarHora(config.ter_abertura)} às {formatarHora(config.ter_intervalo_abertura)}
                        </span>
                        <span style={{ gridColumn: '2', paddingTop: '0' }}>
                          {formatarHora(config.ter_intervalo_fechamento)} às {formatarHora(config.ter_fechamento)}
                        </span>
                      </>
                    )}
                  </div>
                )}
                {config.terca == 0 && (
                  <div
                    className="info-card-block"
                    style={hoje.getDay() == 2 ? { color: 'red', background: '#f9f9f9' } : { color: 'silver' }}
                  >
                    <span style={{ marginLeft: '15px' }}>Terça</span>
                    <span>Não Abre</span>
                  </div>
                )}

                {config.quarta == 1 && (
                  <div
                    className="info-card-block"
                    style={
                      hoje.getDay() == 3
                        ? { color: statusLoja.StatusLoja ? 'rgb(0, 180, 164)' : 'red', background: '#f9f9f9' }
                        : {}
                    }
                  >
                    <span
                      style={{
                        marginLeft: '15px',
                        marginTop: config.qua_intervalo == 1 ? '15px' : '0',
                        gridRow: config.qua_intervalo == 1 ? '1 / 3' : '1 / 2',
                      }}
                    >
                      Quarta
                    </span>
                    {config.qua_intervalo == 0 && (
                      <span>
                        {formatarHora(config.qua_abertura)} às {formatarHora(config.qua_fechamento)}
                      </span>
                    )}
                    {config.qua_intervalo == 1 && (
                      <>
                        <span>
                          {formatarHora(config.qua_abertura)} às {formatarHora(config.qua_intervalo_abertura)}
                        </span>
                        <span style={{ gridColumn: '2', paddingTop: '0' }}>
                          {formatarHora(config.qua_intervalo_fechamento)} às {formatarHora(config.qua_fechamento)}
                        </span>
                      </>
                    )}
                  </div>
                )}
                {config.quarta == 0 && (
                  <div
                    className="info-card-block"
                    style={hoje.getDay() == 3 ? { color: 'red', background: '#f9f9f9' } : { color: 'silver' }}
                  >
                    <span style={{ marginLeft: '15px' }}> Quarta</span>
                    <span>Não Abre</span>
                  </div>
                )}

                {config.quinta == 1 && (
                  <div
                    className="info-card-block"
                    style={
                      hoje.getDay() == 4
                        ? { color: statusLoja.StatusLoja ? 'rgb(0, 180, 164)' : 'red', background: '#f9f9f9' }
                        : {}
                    }
                  >
                    <span
                      style={{
                        marginLeft: '15px',
                        marginTop: config.qui_intervalo == 1 ? '15px' : '0',
                        gridRow: config.qui_intervalo == 1 ? '1 / 3' : '1 / 2',
                      }}
                    >
                      Quinta
                    </span>
                    {config.qui_intervalo == 0 && (
                      <span>
                        {formatarHora(config.qui_abertura)} às {formatarHora(config.qui_fechamento)}
                      </span>
                    )}
                    {config.qui_intervalo == 1 && (
                      <>
                        <span>
                          {formatarHora(config.qui_abertura)} às {formatarHora(config.qui_intervalo_abertura)}
                        </span>
                        <span style={{ gridColumn: '2', paddingTop: '0' }}>
                          {formatarHora(config.qui_intervalo_fechamento)} às {formatarHora(config.qui_fechamento)}
                        </span>
                      </>
                    )}
                  </div>
                )}
                {config.quinta == 0 && (
                  <div
                    className="info-card-block"
                    style={hoje.getDay() == 4 ? { color: 'red', background: '#f9f9f9' } : { color: 'silver' }}
                  >
                    <span style={{ marginLeft: '15px' }}>Quinta</span>
                    <span>Não Abre</span>
                  </div>
                )}

                {config.sexta == 1 && (
                  <div
                    className="info-card-block"
                    style={
                      hoje.getDay() == 5
                        ? { color: statusLoja.StatusLoja ? 'rgb(0, 180, 164)' : 'red', background: '#f9f9f9' }
                        : {}
                    }
                  >
                    <span
                      style={{
                        marginLeft: '15px',
                        marginTop: config.sex_intervalo == 1 ? '15px' : '0',
                        gridRow: config.sex_intervalo == 1 ? '1 / 3' : '1 / 2',
                      }}
                    >
                      Sexta
                    </span>
                    {config.sex_intervalo == 0 && (
                      <span>
                        {formatarHora(config.sex_abertura)} às {formatarHora(config.sex_fechamento)}
                      </span>
                    )}
                    {config.sex_intervalo == 1 && (
                      <>
                        <span>
                          {formatarHora(config.sex_abertura)} às {formatarHora(config.sex_intervalo_abertura)}
                        </span>
                        <span style={{ gridColumn: '2', paddingTop: '0' }}>
                          {formatarHora(config.sex_intervalo_fechamento)} às {formatarHora(config.sex_fechamento)}
                        </span>
                      </>
                    )}
                  </div>
                )}
                {config.sexta == 0 && (
                  <div
                    className="info-card-block"
                    style={hoje.getDay() == 5 ? { color: 'red', background: '#f9f9f9' } : { color: 'silver' }}
                  >
                    <span style={{ marginLeft: '15px' }}>Sexta</span>
                    <span>Não Abre</span>
                  </div>
                )}

                {config.sabado == 1 && (
                  <div
                    className="info-card-block"
                    style={
                      hoje.getDay() == 6
                        ? {
                          color: statusLoja.StatusLoja ? 'rgb(0, 180, 164)' : 'red',
                          background: '#f9f9f9',
                          border: 'none',
                        }
                        : { border: 'none' }
                    }
                  >
                    <span
                      style={{
                        marginLeft: '15px',
                        marginTop: config.sab_intervalo == 1 ? '15px' : '0',
                        gridRow: config.sab_intervalo == 1 ? '1 / 3' : '1 / 2',
                      }}
                    >
                      Sábado
                    </span>
                    {config.sab_intervalo == 0 && (
                      <span>
                        {formatarHora(config.sab_abertura)} às {formatarHora(config.sab_fechamento)}
                      </span>
                    )}
                    {config.sab_intervalo == 1 && (
                      <>
                        <span>
                          {formatarHora(config.sab_abertura)} às {formatarHora(config.sab_intervalo_abertura)}
                        </span>
                        <span style={{ gridColumn: '2', paddingTop: '0' }}>
                          {formatarHora(config.sab_intervalo_fechamento)} às {formatarHora(config.sab_fechamento)}
                        </span>
                      </>
                    )}
                  </div>
                )}
                {config.sabado == 0 && (
                  <div
                    className="info-card-block"
                    style={
                      hoje.getDay() == 6
                        ? { color: 'red', background: '#f9f9f9', border: 'none' }
                        : { color: 'silver', border: 'none' }
                    }
                  >
                    <span style={{ marginLeft: '15px' }}>Sábado</span>
                    <span>Não Abre</span>
                  </div>
                )}
              </div>
            </div>

            <div className="info-card-border-bottom" style={{ paddingBottom: '0' }}>
              <h5 className="info-card-title">Entrega</h5>
              <div className="grid-col-2" style={{ margin: '20px 0' }}>
                <span>Valor Mínimo: </span>
                <span>{config.valor_minimo.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
                <span>Previsão: </span>
                <span> {config.previsao_entrega} min</span>
                <span>Taxa: </span>

                <span>
                  {config.taxa_tipo == 'R$' && FormataValor(config.taxa_valor)}
                  {config.taxa_tipo == '%' && config.taxa_valor + config.taxa_tipo}
                  {config.taxa_tipo == 'Região' && (
                    <Button
                      className="btnWhiteFino"
                      text="Ver no Mapa"
                      onClick={() => handleModal('AREA_ATENDIMENTO', 'Área de Atendimento')}
                    />
                  )}
                  {config.taxa_tipo == 'Regiao' && (
                    <Button
                      className="btnWhiteFino"
                      text="Ver no Mapa"
                      onClick={() => handleModal('AREA_ATENDIMENTO', 'Área de Atendimento')}
                    />
                  )}
                </span>
              </div>
              {config.taxa_tipo == 'Km' && (
                <div
                  style={{
                    padding: '0px 15px 10px',
                    margin: '0.5rem -10px',
                  }}
                >
                  {dadosApp.TabelaTaxaKm.map((item, index) => (
                    <div
                      key={index}
                      className="grid-col-2"
                      style={{ marginTop: '.5rem', paddingTop: '.5rem', borderTop: '1px solid #ebebeb' }}
                    >
                      <span style={{ marginLeft: '10px' }}>
                        {index == 0
                          ? item.km_inicio + ' a ' + item.km_final + ' Km'
                          : dadosApp.TabelaTaxaKm[index - 1].km_final + ' a ' + item.km_final + ' Km'}
                      </span>
                      <span>{FormataValor(item.valor)}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="info-card-border-bottom">
              <h6 className="info-card-title">Nosso Endereço</h6>
              <div className="info-card-content">
                <p>
                  {Capitalize(dados.endereco)}, {dados.endereco_numero} - {Capitalize(dados.endereco_bairro)} -{' '}
                  {dados.endereco_estado.toUpperCase()}
                </p>
              </div>
            </div>

            <div className="info-card-border-bottom">
              <h6 className="info-card-title">Contato</h6>
              <div className="grid-col-2" style={{ overflowWrap: 'anywhere', gridTemplateColumns: '25% 75%' }}>
                <span>Tel: </span>
                <span>
                  ({dados.telefone_ddd}) {dados.telefone}
                </span>
                <span>Email:</span>
                <span>{dados.email.toLowerCase()}</span>
              </div>
            </div>
          </>


        </div>
      )}
      {tabActive === 1 && (
        <InformacaoPagamento />
      )}

    </div>
  );
};

Informacoes.propTypes = {
  handleModal: P.func,
};
